import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { deleteInitiativesUnsyncJiraSlice } from './@async/delete';
import { postInitiativesSyncJiraSlice } from './@async/post';

export const jiraInitiativesSyncReducers = combineReducers({
	delete: deleteInitiativesUnsyncJiraSlice.asyncReducers,
	post: postInitiativesSyncJiraSlice.asyncReducers
});

export const jiraInitiativesSyncWatchers = combineAllWatchers([
	deleteInitiativesUnsyncJiraSlice.asyncWatchers,
	postInitiativesSyncJiraSlice.asyncWatchers
]);
